module.exports = __webpack_public_path__ + "img/TV_1.25d5135a.webp";